const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { login: loginApi } = require("@doctoroncallcom/api/marketplace");
const { LOGIN } = require("./constants");

const { loginSuccess, loginError } = require("./actions");

const login = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(LOGIN),
    mergeMap((action) =>
      loginApi
        .login(marketplace, {
          access_token: action.payload.accessToken,
        })
        .then((response) => loginSuccess(response.data))
        .catch((error) => loginError(error))
    )
  );

module.exports = {
  login,
};
